import s from './LoginWidget.module.css';
import { Button, Checkbox, Input } from '@cian/ui-kit';
import { Countdown } from './Countdown';

interface SmsWindowProps {
  uuid: string;
  phone: string;
  code: string;
  codeError: boolean;
  agreementsChecked: boolean;
  setCodeError(v: boolean): void;
  setAgreementsChecked(v: boolean): void;
  onEnterCode(code: string): void;
  setCode(code: string): void;
  onResetPhone(): void;
  onResendPhone(): void;
  onShowAgreements(): void;
}

export function SmsWindow({
  uuid,
  phone,
  codeError,
  setCodeError,
  onEnterCode,
  onResetPhone,
  onShowAgreements,
  onResendPhone,
  agreementsChecked,
  setAgreementsChecked,
  code,
  setCode,
}: SmsWindowProps) {
  function onLinkClick(e: React.MouseEvent) {
    e.preventDefault();
    onShowAgreements();
  }

  function handleChangeCode(e: React.ChangeEvent<HTMLInputElement>) {
    setCodeError(false);
    setCode(e.target.value);
  }

  const label = (
    <span>
      {/* eslint-disable-next-line no-irregular-whitespace */}
      Соглашаюсь на 
      <a href="#" onClick={onLinkClick} className={s.link}>
        обработку персональных данных
      </a>
    </span>
  ) as unknown as string;

  return (
    <div>
      <p className={s.message}>
        Отправили его на <strong>{phone}</strong>
      </p>
      <button className={s['reset-phone-button']} onClick={onResetPhone}>
        Изменить номер
      </button>
      <Input maxWidth={124} onChange={handleChangeCode} value={code} placeholder="Код" />
      <p className={s['code-error']}>{codeError && 'Неправильный код'}</p>
      <Countdown key={uuid} onResendPhone={onResendPhone} />
      <div className={s['agreements-block']}>
        <Checkbox checked={agreementsChecked} label={label} onChange={() => setAgreementsChecked(!agreementsChecked)} />
      </div>
      <Button disabled={!agreementsChecked || code.length !== 4} onClick={() => onEnterCode(code)}>
        Подтвердить
      </Button>
    </div>
  );
}
